@if (!(isMobile$ | async)) {
  <mat-toolbar color="accent" class="ngx-navbar" [class.ngx-navbar--next-gen]="isNextGen$ | async">
    <br>
      @if (!(isNextGen$ |async)) {
        <span routerLink="/" >
          <img alt="Spotlight" class="ngx-navbar__logo" [src]="(isDarkMode$ | async) ? darkLogoUrl : lightLogoUrl">
        </span>
      }
      @if (showNavLinks && !(isNextGen$ |async)) {
        <nav mat-tab-nav-bar [disablePagination]="true" [tabPanel]="tabNavPanel">
          @for (link of navLinks; track link.url; let i = $index) {
            @if (!link.mobileOnly) {
              <span
                mat-tab-link
                class="ngx-navbar__tab-elements"
                [routerLink]="link.url"
                [ngClass]="{'ngx-navbar__active': link.active}"
                [active]="link.active">
                {{link.label}}
              </span>
            }
          }
        </nav>
      }
      <mat-tab-nav-panel #tabNavPanel>
      </mat-tab-nav-panel>
      <span fxFlex></span>
      <ng-template #locationNameDisplay>
        <img class="ngx-navbar__location-pin"
          src="assets/img/location-pin-icon.svg"
          alt=""
          aria-hidden="true">
        <span class="ngx-navbar__location-name"
          [attr.data-testid]="selectedLocationDisplayName + '-name'">
          {{ selectedLocationDisplayName }}
        </span>
      </ng-template>
      @if ({ nextGenSwitcher: !!(isNextGen$ | async) }; as switcherCtx) {
        @if (switcherCtx.nextGenSwitcher && !isMultiLocation) {
          <div
            class="ngx-navbar__location-static"
            data-testid="location-switcher-single">
            <ng-container *ngTemplateOutlet="locationNameDisplay"></ng-container>
          </div>
        }
        @if ((switcherCtx.nextGenSwitcher && isMultiLocation) || !switcherCtx.nextGenSwitcher) {
          <mat-form-field
            appearance="fill"
            [ngClass]="selectedLocationDisplayName.length > 18 ? 'ngx-navbar__select-long' : 'ngx-navbar__select'"
            data-testid="select-location-dropdown-container">
            <mat-select #locationMenu
              [panelClass]="switcherCtx.nextGenSwitcher ? 'ngx-navbar__panel ngx-navbar__panel--next-gen' : 'ngx-navbar__panel'"
              [panelWidth]="switcherCtx.nextGenSwitcher ? '265px' : null"
              [ngModel]="selectedLocation"
              [compareWith]="compareLocations"
              [disabled]="stateDisabled()"
              (selectionChange)="updateLocation($event.value, switcherCtx.nextGenSwitcher)"
              (closed)="clearLocationFiltering()">
              <mat-select-trigger>
                @if (switcherCtx.nextGenSwitcher) {
                  <span
                    class="ngx-navbar__location-trigger-content">
                    <img class="ngx-navbar__location-pin"
                      src="assets/img/location-pin-icon.svg"
                      alt=""
                      aria-hidden="true">
                    <span class="ngx-navbar__location-name"
                      [attr.data-testid]="selectedLocationDisplayName + '-name'">
                      {{ selectedLocationDisplayName }}
                    </span>
                  </span>
                } @else {
                  <div style="margin-top:-7px">
                    <button mat-icon-button (click)="locationMenu.open()">
                      <mat-icon class="ngx-navbar__view-icon">location_on</mat-icon>
                      <span class="ngx-navbar__location-name" [attr.data-testid]="selectedLocationDisplayName + '-name'">
                        {{ selectedLocationDisplayName }}
                      </span>
                    </button>
                  </div>
                }
              </mat-select-trigger>
              @if (shouldUseLocationSearch(locations ?? [], pageSize)) {
                <mat-form-field appearance="fill" class="ngx-navbar__search">
                  <mat-icon matPrefix class="ngx-navbar__search-icon">search</mat-icon>
                  <input matInput
                    [value]="searchTerm"
                    data-testid="select-location-search-input"
                    placeholder="Search Locations"
                    (keyup)="onSearch($event)"
                    (keydown)="$event.stopPropagation()">
                </mat-form-field>
              }
              @for (loc of getDisplayLocations$() | async; track loc.locationNumber) {
                <mat-option
                  [value]="loc ? loc : []"
                  [attr.data-testid]="loc?.locationName + '-option'"
                  [disabled]="!loc?.locationName">
                  <span class="ngx-navbar__option-row">
                    @if (loc?.locationNumber && compareLocations(loc, selectedLocation)) {
                      <mat-icon
                        class="ngx-navbar__selected-icon"
                        aria-label="Currently selected location"
                      [attr.data-testid]="loc?.locationName + '-selected-icon'">check</mat-icon>
                    }
                    <span class="ngx-navbar__option-label">{{loc.locationName ? loc?.locationName : 'N/A'}}</span>
                    @if (loc?.locationNumber) {
                      <button
                        type="button"
                        class="ngx-navbar__favorite-star"
                        [class.ngx-navbar__favorite-star--active]="favoriteLocationNumbers.includes(loc.locationNumber)"
                        [attr.aria-label]="favoriteLocationNumbers.includes(loc.locationNumber) ? 'Remove from favorites' : 'Add to favorites'"
                        [attr.data-testid]="loc?.locationName + '-favorite-star'"
                        (click)="$event.stopPropagation(); toggleFavorite(loc)">
                        <mat-icon>{{ favoriteLocationNumbers.includes(loc.locationNumber) ? 'star' : 'star_border' }}</mat-icon>
                      </button>
                    }
                  </span>
                </mat-option>
              }
              @if (shouldUseLocationSearch(locations ?? [], pageSize)) {
                <pagination
                  [totalElements]="(getFilteredLocations$() | async).length"
                  [pageSize]="pageSize"
                  [currentPage]="currentPage"
                  (pageRight)="pageRight()"
                  (pageLeft)="pageLeft()">
                </pagination>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (switcherCtx.nextGenSwitcher) {
          <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            class="ngx-navbar__profile-button"
            aria-label="User account"
            data-testid="user-account-menu-trigger">
            <span class="ngx-navbar__profile-avatar">
              <img class="ngx-navbar__profile-icon"
                src="assets/img/profile-avatar-icon.svg"
                alt=""
                aria-hidden="true">
            </span>
          </button>
        }
        @if (!switcherCtx.nextGenSwitcher) {
          <span fxFlex.gt-sm="30px" fxFlex="1px"></span>
        }
        @if (!switcherCtx.nextGenSwitcher) {
          <div class="ngx-navbar__menu-container">
            <button mat-icon-button [matMenuTriggerFor]="menu"
              matBadge = "{{(unreadNotificationCount$ | async) > 0 ? (unreadNotificationCount$ | async)  : ''}}">
              <mat-icon class="ngx-navbar__menu-icon">menu</mat-icon>
            </button>
          </div>
        }
      }
      <mat-menu #menu="matMenu" class="ngx-navbar__menu">
        <button mat-menu-item (click)="openNotifications()">
          <mat-icon>notifications</mat-icon>
          <span>Notifications
            @if ((unreadNotificationCount$ | async) > 0) {
              <span class="ngx-navbar__notification-number">
                {{unreadNotificationCount$ | async}} new
              </span>
            }
          </span>
        </button>
        <button mat-menu-item (click)="openSettings()">
          <mat-icon>settings</mat-icon>
          <span>Settings</span>
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logoutUser()">
          <mat-icon>exit_to_app</mat-icon>
          <span>Logout</span>
        </button>
      </mat-menu>
    </mat-toolbar>
  }
  @if ((isMobile$ | async) && !(isNextGen$ | async)) {
    <mat-toolbar>
      <mat-toolbar-row class="ngx-navbar-mobile__header" fxLayout="row" fxLayoutAlign="space-between center">
        <button type="button" class="ngx-navbar-mobile__location-container cfa-plain-button"
          [ngClass]="{'ngx-navbar-mobile__location-visibility-hide': !showLocationNumber}"
          (click)="navigateToMenu()"
         >
          <span>
            <img alt="Location Marker Icon"
              class="ngx-navbar-mobile__location-icon"
              src="https://www.cfacdn.com/img/Spotlight/Icons/Location_Marker.png">
            </span>
            <span class="ngx-navbar-mobile__location-number" [attr.data-testid]="'mobile-' + (selectedLocation$ | async)?.locationNumber + '-number'">
              {{(selectedLocation$ | async)?.locationNumber}}
            </span>
          </button>
          <div routerLink="/" class="ngx-navbar-mobile__logo-container">
            <img alt="Spotlight"
              class="ngx-navbar-mobile__logo"
              [src]="(isDarkMode$ | async) ? darkLogoUrl : lightLogoUrl">
          </div>
          <div routerLink="/menu" class="ngx-navbar-mobile__menu-container">
            <img alt="Sandwich Menu Bar Icon"
              class="ngx-navbar-mobile__menu"
              src="https://www.cfacdn.com/img/Spotlight/Icons/Mobile_Menu.png">
            </div>
          </mat-toolbar-row>
          @if (showSelectedLocationName) {
            <mat-toolbar-row class="ngx-navbar-mobile__subheader"
              fxLayout="row" fxLayoutAlign="center center">
            <button type="button" (click)="navigateToMenu()" class="cfa-plain-button cfa-plain-button--inline">
              <span>
                <img alt="Location Marker Icon"
                  class="ngx-navbar-mobile__location-icon"
                  src="https://www.cfacdn.com/img/Spotlight/Icons/Location_Marker.png">
                </span>
                <span class="ngx-navbar-mobile__location-number ngx-navbar-mobile__location-number-margin" [attr.data-testid]="'mobile-' + (selectedLocation$ | async)?.locationName + '-name'">
                  {{(selectedLocation$ | async)?.locationName ? (selectedLocation$ | async)?.locationName : 'N/A'}}
                </span>
              </button>
            </mat-toolbar-row>
          }
        </mat-toolbar>
      }
      @if (showNavLinks && (isMobile$ | async) && !(isNextGen$ | async)) {
        <navbar-footer
          [navLinks]=navLinks>
      </navbar-footer>
    }
